import CountdownMessage from "@JohnLewisPartnership/jl-design-system/dist/components/countdown-message/CountdownMessage";
import styles from "./ClickAndCollectCountdown.module.scss";

type Props = {
  /**
   * A string representing the order by local time today. It can also be null or undefined.
   */
  orderByLocalTimeToday: string | null | undefined;
  /**
   * A string representing the collect from local time tomorrow. It can also be null or undefined.
   */
  collectFromLocalTimeTomorrow: string | null | undefined;
  /**
   * A number representing the duration.
   */
  duration: number;
};

const DEFAULT_CUTOFF = 19;
const DEFAULT_COLLECTION = "3pm";

const getHoursFromTime = (
  time: string | null | undefined,
): number | undefined => {
  if (!time) return;
  // @ts-ignore
  return parseInt(time.split(":")[0]);
};

const convertToAMPM = (time: string | null | undefined) => {
  const hour = getHoursFromTime(time);

  if (!hour) return null;

  if (hour > 12) {
    return `${hour - 12}pm`;
  } else {
    return `${hour}am`;
  }
};

export const ClickAndCollectCountdownUI = ({
  orderByLocalTimeToday,
  collectFromLocalTimeTomorrow,
  duration,
}: Props) => {
  return (
    <div
      data-testid="click-and-collect-countdown-wrapper"
      className={styles.clickAndCollectCountdown}
    >
      <CountdownMessage
        cutOffTime={getHoursFromTime(orderByLocalTimeToday) || DEFAULT_CUTOFF}
        duration={duration}
        message={`Order in the next {time} to collect in-store from ${
          convertToAMPM(collectFromLocalTimeTomorrow) || DEFAULT_COLLECTION
        } tomorrow`}
      />
    </div>
  );
};
